import {
  emailRegex,
  partialSkuRegex,
  passwordRegex,
  skuRegex,
  urlRegex,
} from "../constants/Variables";

const loginValidation = (obj, setInputError) => {
  let errors = {};

  if (!obj.email?.trim()) {
    errors.email = "validation.emailRequired";
  }
  if (obj.email?.trim() && !emailRegex.test(obj.email)) {
    errors.email = "validation.invalidEmailFormat";
  }

  if (!obj.password?.trim()) {
    errors.password = "validation.passwordRequired";
  }

  setInputError(errors);
  return Object.keys(errors).length > 0;
};

const signupValidation = (obj, setInputError) => {
  let hasError = false;

  if (!obj.name) {
    setInputError((prev) => ({ ...prev, name: true }));
    hasError = true;
  }
  if (!obj.email) {
    setInputError((prev) => ({ ...prev, email: true }));
    hasError = true;
  }
  if (obj.email && !emailRegex.test(obj.email)) {
    setInputError((prev) => ({ ...prev, isEmailValid: true }));
    hasError = true;
  }

  if (!obj.location) {
    setInputError((prev) => ({ ...prev, location: true }));
    hasError = true;
  }

  if (!obj.type) {
    setInputError((prev) => ({ ...prev, type: true }));
    hasError = true;
  }

  if (!obj.password) {
    setInputError((prev) => ({ ...prev, password: true }));
    hasError = true;
  }

  return hasError;
};

const forgotValidation = (obj, setInputError) => {
  let hasError = false;

  if (!obj.email) {
    setInputError((prev) => ({ ...prev, email: true }));
    hasError = true;
  }
  if (obj.email && !emailRegex.test(obj.email)) {
    setInputError((prev) => ({ ...prev, isEmailValid: true }));
    hasError = true;
  }

  return hasError;
};

const resetValidation = (obj, setInputError) => {
  let hasError = false;

  if (!obj.password) {
    setInputError((prev) => ({ ...prev, password: true }));
    hasError = true;
  }

  if (!obj.confirmPass) {
    setInputError((prev) => ({ ...prev, confirmPass: true }));
    hasError = true;
  }

  if (obj.password !== obj.confirmPass) {
    setInputError((prev) => ({ ...prev, isPasswordValid: true }));
    hasError = true;
  }

  return hasError;
};

const serviceCategoryValidation = (obj, setInputError) => {
  let errors = {};

  if (!obj.image) {
    errors.image = "validation.imageRequired";
  }

  if (!obj.name_ro?.trim()) {
    errors.name_ro = "validation.categoryNameRequiredInRomanian";
  } else if (obj.name_ro?.trim().length > 60) {
    errors.name_ro = "validation.categoryNameIsTooLong";
  }

  if (!obj.name_en?.trim()) {
    errors.name_en = "validation.categoryNameRequiredInEnglish";
  } else if (obj.name_en?.trim().length > 60) {
    errors.name_en = "validation.categoryNameIsTooLong";
  }

  if (!obj.description_ro?.trim()) {
    errors.description_ro = "validation.categoryDescriptionRequiredInRomanian";
  } else if (obj.description_ro?.trim().length > 255) {
    errors.description_ro = "validation.categoryDescriptionIsTooLong";
  }

  if (!obj.description_en?.trim()) {
    errors.description_en = "validation.categoryDescriptionRequiredInEnglish";
  } else if (obj.description_en?.trim().length > 255) {
    errors.description_en = "validation.categoryDescriptionIsTooLong";
  }

  if (!obj.metaTitle_ro?.trim()) {
    errors.metaTitle_ro = "validation.categoryMetaTitleRequiredInRomanian";
  } else if (obj.metaTitle_ro?.trim().length > 60) {
    errors.metaTitle_ro = "validation.categoryMetaTitleIsTooLong";
  }

  if (!obj.metaTitle_en?.trim()) {
    errors.metaTitle_en = "validation.categoryMetaTitleRequiredInEnglish";
  } else if (obj.metaTitle_en?.trim().length > 60) {
    errors.metaTitle_en = "validation.categoryMetaTitleIsTooLong";
  }

  if (!obj.metaDescription_ro?.trim()) {
    errors.metaDescription_ro =
      "validation.categoryMetaDescriptionRequiredInRomanian";
  } else if (obj.metaDescription_ro?.trim().length > 255) {
    errors.metaDescription_ro = "validation.categoryMetaDescriptionIsTooLong";
  }

  if (!obj.metaDescription_en?.trim()) {
    errors.metaDescription_en =
      "validation.categoryMetaDescriptionRequiredInEnglish";
  } else if (obj.metaDescription_en?.trim().length > 255) {
    errors.metaDescription_en = "validation.categoryMetaDescriptionIsTooLong";
  }

  if (!obj.metaKeywords_ro?.length) {
    errors.metaKeywords_ro =
      "validation.categoryMetaKeywordsRequiredInRomanian";
  } else if (obj.metaKeywords_ro?.length > 10) {
    errors.metaKeywords_ro = "validation.categoryMetaKeywordsTooLong";
  }

  if (!obj.metaKeywords_en?.length) {
    errors.metaKeywords_en = "validation.categoryMetaKeywordsRequiredInEnglish";
  } else if (obj.metaKeywords_en?.length > 10) {
    errors.metaKeywords_en = "validation.categoryMetaKeywordsTooLong";
  }

  setInputError(errors);
  return Object.keys(errors).length > 0;
};

const serviceSubCategoryValidation = (duration, obj, setInputError) => {
  let errors = {};

  if (!obj.image) {
    errors.image = "validation.imageRequired";
  }

  if (!obj.smallIcon) {
    errors.smallIcon = "validation.iconRequired";
  }

  if (!obj.type) {
    errors.type = "validation.selectServiceType";
  }

  if (isNaN(obj.sortingNum)) {
    errors.sortingNum = "validation.sortingNumberRequired";
  } else if (obj.sortingNum < 0) {
    errors.sortingNum = "validation.sortingNumberMustBeGreaterThanZero";
  }

  if (!obj.name_en?.trim()) {
    errors.name_en = "validation.categoryNameRequiredInEnglish";
  } else if (obj.name_en?.trim().length > 60) {
    errors.name_en = "validation.categoryNameIsTooLong";
  }

  if (!obj.name_ro?.trim()) {
    errors.name_ro = "validation.categoryNameRequiredInRomanian";
  } else if (obj.name_ro?.trim().length > 60) {
    errors.name_ro = "validation.categoryNameIsTooLong";
  }

  if (!obj.description_en?.trim()) {
    errors.description_en = "validation.categoryDescriptionRequiredInEnglish";
  } else if (obj.description_en?.trim().length > 255) {
    errors.description_en = "validation.categoryDescriptionIsTooLong";
  }

  if (!obj.description_ro?.trim()) {
    errors.description_ro = "validation.categoryDescriptionRequiredInRomanian";
  } else if (obj.description_ro?.trim().length > 255) {
    errors.description_ro = "validation.categoryDescriptionIsTooLong";
  }

  if (!obj.metaTitle_en?.trim()) {
    errors.metaTitle_en = "validation.categoryMetaTitleRequiredInEnglish";
  } else if (obj.metaTitle_en?.trim().length > 60) {
    errors.metaTitle_en = "validation.categoryMetaTitleIsTooLong";
  }

  if (!obj.metaTitle_ro?.trim()) {
    errors.metaTitle_ro = "validation.categoryMetaTitleRequiredInRomanian";
  } else if (obj.metaTitle_ro?.trim().length > 60) {
    errors.metaTitle_ro = "validation.categoryMetaTitleIsTooLong";
  }

  if (!obj.metaDescription_en?.trim()) {
    errors.metaDescription_en =
      "validation.categoryMetaDescriptionRequiredInEnglish";
  } else if (obj.metaDescription_en?.trim().length > 255) {
    errors.metaDescription_en = "validation.categoryMetaDescriptionIsTooLong";
  }

  if (!obj.metaDescription_ro?.trim()) {
    errors.metaDescription_ro =
      "validation.categoryMetaDescriptionRequiredInRomanian";
  } else if (obj.metaDescription_ro?.trim().length > 255) {
    errors.metaDescription_ro = "validation.categoryMetaDescriptionIsTooLong";
  }

  if (!obj.metaKeywords_ro?.length) {
    errors.metaKeywords_ro =
      "validation.categoryMetaKeywordsRequiredInRomanian";
  } else if (obj.metaKeywords_ro?.length > 10) {
    errors.metaKeywords_ro = "validation.categoryMetaKeywordsTooLong";
  }

  if (!obj.metaKeywords_en?.length) {
    errors.metaKeywords_en = "validation.categoryMetaKeywordsRequiredInEnglish";
  } else if (obj.metaKeywords_en?.length > 10) {
    errors.metaKeywords_en = "validation.categoryMetaKeywordsTooLong";
    // alert("metaKeywords_en is too long");
  }

  if (isNaN(obj.profitPer)) {
    errors.profitPer = "validation.profitPercentageRequired";
  } else if (obj.profitPer < 0 || obj.profitPer > 100) {
    errors.profitPer = "validation.profitPercentageMustBeBetween0And100";
  }

  const areaDuration =
    obj.type && (obj.type === "area" || obj.type === "room+area");

  if (areaDuration && isNaN(duration?.area)) {
    errors.area = "validation.areaDurationMustBeNumber";
  } else if (areaDuration && !duration?.area) {
    errors.area = "validation.areaDurationRequired";
  } else if (areaDuration && duration?.area < 0) {
    errors.area = "validation.areaDurationMustBeGreaterThanZero";
  }

  const roomDuration = obj.type && obj.type === "room+area";

  if (roomDuration && isNaN(duration?.room)) {
    errors.room = "validation.roomDurationMustBeNumber";
  } else if (roomDuration && !duration?.room) {
    errors.room = "validation.roomDurationRequired";
  } else if (roomDuration && duration?.room < 0) {
    errors.room = "validation.roomDurationMustBeGreaterThanZero";
  }

  const interiorDuration = obj.type && obj.type === "interior+exterior";

  if (interiorDuration && isNaN(duration?.interior)) {
    errors.interior = "validation.interiorDurationMustBeNumber";
  } else if (interiorDuration && !duration?.interior) {
    errors.interior = "validation.interiorDurationRequired";
  } else if (interiorDuration && duration?.interior < 0) {
    errors.interior = "validation.interiorDurationMustBeGreaterThanZero";
  }

  const exteriorDuration = obj.type && obj.type === "interior+exterior";

  if (exteriorDuration && isNaN(duration?.exterior)) {
    errors.exterior = "validation.exteriorDurationMustBeNumber";
  } else if (exteriorDuration && !duration?.exterior) {
    errors.exterior = "validation.exteriorDurationRequired";
  } else if (exteriorDuration && duration?.exterior < 0) {
    errors.exterior = "validation.exteriorDurationMustBeGreaterThanZero";
  }

  const fixedDuration = obj.type && obj.type === "fixed";

  if (fixedDuration && isNaN(duration?.fixed)) {
    errors.fixed = "validation.fixedDurationMustBeNumber";
  } else if (fixedDuration && !duration?.fixed) {
    errors.fixed = "validation.fixedDurationRequired";
  } else if (fixedDuration && duration?.fixed < 0) {
    errors.fixed = "validation.fixedDurationMustBeGreaterThanZero";
  }

  if (!obj.longDescription_ro?.trim()) {
    errors.longDescription_ro = "validation.longDescriptionRequiredInRomanian";
  }

  if (!obj.longDescription_en?.trim()) {
    errors.longDescription_en = "validation.longDescriptionRequiredInEnglish";
  }

  setInputError(errors);
  return Object.keys(errors).length > 0;
};

const addEcomCategoryValidation = (obj, setInputError) => {
  let errors = {};

  if (!obj.image) {
    errors.image = "validation.imageRequired";
  }
  if (!obj.smallIcon) {
    errors.smallIcon = "validation.categoryIconRequired";
  }

  if (isNaN(obj.sortingNum)) {
    errors.sortingNum = "validation.sortingNumberRequired";
  } else if (obj.sortingNum < 0) {
    errors.sortingNum = "validation.sortingNumberMustBeGreaterThanZero";
  }

  if (!obj.name_ro?.trim()) {
    errors.name_ro = "validation.categoryNameRequiredInRomanian";
  } else if (obj.name_ro?.trim().length > 60) {
    errors.name_ro = "validation.categoryNameIsTooLong";
  }

  if (!obj.name_en?.trim()) {
    errors.name_en = "validation.categoryNameRequiredInEnglish";
  } else if (obj.name_en?.trim().length > 60) {
    errors.name_en = "validation.categoryNameIsTooLong";
  }

  if (!obj.description_ro?.trim()) {
    errors.description_ro = "validation.categoryDescriptionRequiredInRomanian";
  } else if (obj.description_ro?.trim().length > 255) {
    errors.description_ro = "validation.categoryDescriptionIsTooLong";
  }

  if (!obj.description_en?.trim()) {
    errors.description_en = "validation.categoryDescriptionRequiredInEnglish";
  } else if (obj.description_en?.trim().length > 255) {
    errors.description_en = "validation.categoryDescriptionIsTooLong";
  }

  if (!obj.metaTitle_ro?.trim()) {
    errors.metaTitle_ro = "validation.categoryMetaTitleRequiredInRomanian";
  } else if (obj.metaTitle_ro?.trim().length > 60) {
    errors.metaTitle_ro = "validation.categoryMetaTitleIsTooLong";
  }

  if (!obj.metaTitle_en?.trim()) {
    errors.metaTitle_en = "validation.categoryMetaTitleRequiredInEnglish";
  } else if (obj.metaTitle_en?.trim().length > 60) {
    errors.metaTitle_en = "validation.categoryMetaTitleIsTooLong";
  }

  if (!obj.metaDescription_ro?.trim()) {
    errors.metaDescription_ro =
      "validation.categoryMetaDescriptionRequiredInRomanian";
  } else if (obj.metaDescription_ro?.trim().length > 255) {
    errors.metaDescription_ro = "validation.categoryMetaDescriptionIsTooLong";
  }

  if (!obj.metaDescription_en?.trim()) {
    errors.metaDescription_en =
      "validation.categoryMetaDescriptionRequiredInEnglish";
  } else if (obj.metaDescription_en?.trim().length > 255) {
    errors.metaDescription_en = "validation.categoryMetaDescriptionIsTooLong";
  }

  if (!obj.metaKeywords_ro?.length) {
    errors.metaKeywords_ro =
      "validation.categoryMetaKeywordsRequiredInRomanian";
  } else if (obj.metaKeywords_ro?.length > 10) {
    errors.metaKeywords_ro = "validation.categoryMetaKeywordsTooLong";
  }

  if (!obj.metaKeywords_en?.length) {
    errors.metaKeywords_en = "validation.categoryMetaKeywordsRequiredInEnglish";
  } else if (obj.metaKeywords_en?.length > 10) {
    errors.metaKeywords_en = "validation.categoryMetaKeywordsTooLong";
  }

  setInputError(errors);
  return Object.keys(errors).length > 0;
};

const addEditEcomSubCategoryValidation = (obj, setInputError) => {
  let errors = {};

  if (!obj.image) {
    errors.image = "validation.imageRequired";
  }
  if (!obj.smallIcon) {
    errors.smallIcon = "validation.categoryIconRequired";
  }

  if (!obj.categoryId) {
    errors.categoryId = "validation.categoryRequired";
  }

  if (isNaN(obj.sortingNum)) {
    errors.sortingNum = "validation.sortingNumberRequired";
  } else if (obj.sortingNum < 0) {
    errors.sortingNum = "validation.sortingNumberMustBeGreaterThanZero";
  }

  if (!obj.name_ro?.trim()) {
    errors.name_ro = "validation.categoryNameRequiredInRomanian";
  } else if (obj.name_ro?.trim().length > 60) {
    errors.name_ro = "validation.categoryNameIsTooLong";
  }

  if (!obj.name_en?.trim()) {
    errors.name_en = "validation.categoryNameRequiredInEnglish";
  } else if (obj.name_en?.trim().length > 60) {
    errors.name_en = "validation.categoryNameIsTooLong";
  }

  if (!obj.description_ro?.trim()) {
    errors.description_ro = "validation.categoryDescriptionRequiredInRomanian";
  } else if (obj.description_ro?.trim().length > 255) {
    errors.description_ro = "validation.categoryDescriptionIsTooLong";
  }

  if (!obj.description_en?.trim()) {
    errors.description_en = "validation.categoryDescriptionRequiredInEnglish";
  } else if (obj.description_en?.trim().length > 255) {
    errors.description_en = "validation.categoryDescriptionIsTooLong";
  }

  if (!obj.metaTitle_ro?.trim()) {
    errors.metaTitle_ro = "validation.categoryMetaTitleRequiredInRomanian";
  } else if (obj.metaTitle_ro?.trim().length > 60) {
    errors.metaTitle_ro = "validation.categoryMetaTitleIsTooLong";
  }

  if (!obj.metaTitle_en?.trim()) {
    errors.metaTitle_en = "validation.categoryMetaTitleRequiredInEnglish";
  } else if (obj.metaTitle_en?.trim().length > 60) {
    errors.metaTitle_en = "validation.categoryMetaTitleIsTooLong";
  }

  if (!obj.metaDescription_ro?.trim()) {
    errors.metaDescription_ro =
      "validation.categoryMetaDescriptionRequiredInRomanian";
  } else if (obj.metaDescription_ro?.trim().length > 255) {
    errors.metaDescription_ro = "validation.categoryMetaDescriptionIsTooLong";
  }

  if (!obj.metaDescription_en?.trim()) {
    errors.metaDescription_en =
      "validation.categoryMetaDescriptionRequiredInEnglish";
  } else if (obj.metaDescription_en?.trim().length > 255) {
    errors.metaDescription_en = "validation.categoryMetaDescriptionIsTooLong";
  }

  if (!obj.metaKeywords_ro?.length) {
    errors.metaKeywords_ro =
      "validation.categoryMetaKeywordsRequiredInRomanian";
  } else if (obj.metaKeywords_ro?.length > 10) {
    errors.metaKeywords_ro = "validation.categoryMetaKeywordsTooLong";
  }

  if (!obj.metaKeywords_en?.length) {
    errors.metaKeywords_en = "validation.categoryMetaKeywordsRequiredInEnglish";
  } else if (obj.metaKeywords_en?.length > 10) {
    errors.metaKeywords_en = "validation.categoryMetaKeywordsTooLong";
  }

  setInputError(errors);
  return Object.keys(errors).length > 0;
};

const addEditEcomSubSubCategoryValidation = (obj, setInputError) => {
  let errors = {};

  if (!obj.image) {
    errors.image = "validation.imageRequired";
  }
  if (!obj.smallIcon) {
    errors.smallIcon = "validation.iconRequired";
  }

  if (!obj.categoryId) {
    errors.categoryId = "validation.categoryRequired";
  }

  if (!obj.subCategoryId) {
    errors.subCategoryId = "validation.subCategoryRequired";
  }

  if (isNaN(obj.sortingNum)) {
    errors.sortingNum = "validation.sortingNumberRequired";
  } else if (obj.sortingNum < 0) {
    errors.sortingNum = "validation.sortingNumberMustBeGreaterThanZero";
  }

  if (!obj.name_ro?.trim()) {
    errors.name_ro = "validation.categoryNameRequiredInRomanian";
  } else if (obj.name_ro?.trim().length > 60) {
    errors.name_ro = "validation.categoryNameIsTooLong";
  }

  if (!obj.name_en?.trim()) {
    errors.name_en = "validation.categoryNameRequiredInEnglish";
  } else if (obj.name_en?.trim().length > 60) {
    errors.name_en = "validation.categoryNameIsTooLong";
  }

  if (!obj.description_ro?.trim()) {
    errors.description_ro = "validation.categoryDescriptionRequiredInRomanian";
  } else if (obj.description_ro?.trim().length > 255) {
    errors.description_ro = "validation.categoryDescriptionIsTooLong";
  }

  if (!obj.description_en?.trim()) {
    errors.description_en = "validation.categoryDescriptionRequiredInEnglish";
  } else if (obj.description_en?.trim().length > 255) {
    errors.description_en = "validation.categoryDescriptionIsTooLong";
  }

  if (!obj.metaTitle_ro?.trim()) {
    errors.metaTitle_ro = "validation.categoryMetaTitleRequiredInRomanian";
  } else if (obj.metaTitle_ro?.trim().length > 60) {
    errors.metaTitle_ro = "validation.categoryMetaTitleIsTooLong";
  }

  if (!obj.metaTitle_en?.trim()) {
    errors.metaTitle_en = "validation.categoryMetaTitleRequiredInEnglish";
  } else if (obj.metaTitle_en?.trim().length > 60) {
    errors.metaTitle_en = "validation.categoryMetaTitleIsTooLong";
  }

  if (!obj.metaDescription_ro?.trim()) {
    errors.metaDescription_ro =
      "validation.categoryMetaDescriptionRequiredInRomanian";
  } else if (obj.metaDescription_ro?.trim().length > 255) {
    errors.metaDescription_ro = "validation.categoryMetaDescriptionIsTooLong";
  }

  if (!obj.metaDescription_en?.trim()) {
    errors.metaDescription_en =
      "validation.categoryMetaDescriptionRequiredInEnglish";
  } else if (obj.metaDescription_en?.trim().length > 255) {
    errors.metaDescription_en = "validation.categoryMetaDescriptionIsTooLong";
  }

  if (!obj.metaKeywords_ro?.length) {
    errors.metaKeywords_ro =
      "validation.categoryMetaKeywordsRequiredInRomanian";
  } else if (obj.metaKeywords_ro?.length > 10) {
    errors.metaKeywords_ro = "validation.categoryMetaKeywordsTooLong";
  }

  if (!obj.metaKeywords_en?.length) {
    errors.metaKeywords_en = "validation.categoryMetaKeywordsRequiredInEnglish";
  } else if (obj.metaKeywords_en?.length > 10) {
    errors.metaKeywords_en = "validation.categoryMetaKeywordsTooLong";
  }

  setInputError(errors);
  return Object.keys(errors).length > 0;
};

const changePasswordValidation = (obj, setInputError) => {
  let errors = {};

  if (!obj.oldPassword?.trim()) {
    errors.oldPassword = "validation.oldPasswordRequired";
  }

  if (!obj.newPassword?.trim()) {
    errors.newPassword = "validation.newPasswordRequired";
  } else if (obj.newPassword && !passwordRegex.test(obj.newPassword)) {
    errors.newPassword = "validation.invalidPasswordFormat";
  }

  if (!obj.reEnterPassword?.trim()) {
    errors.reEnterPassword = "validation.reEnterPasswordRequired";
  } else if (obj.newPassword !== obj.reEnterPassword) {
    errors.reEnterPassword = "validation.passwordMismatch";
  }

  setInputError(errors);
  return Object.keys(errors).length > 0;
};

const addEditProductValidation = (obj, setInputError, errorRef) => {
  const errors = {};

  if (obj.images?.length < 2) {
    errors.images = "validation.uploadAtLeastTwoImages";
  }

  if (!obj.name_ro?.trim()) {
    errors.name_ro = "validation.productTitleIsRequiredInRomanian";
    if (!errorRef.current) {
      errorRef.current = document.querySelector("#product-name-ro");
    }
  } else if (obj.name_ro?.trim()?.length > 250) {
    errors.name_ro = "validation.productTitleIsTooLongInRomanian";
    if (!errorRef.current) {
      errorRef.current = document.querySelector("#product-name-ro");
    }
  }

  if (!obj.name_en?.trim()) {
    errors.name_en = "validation.productTitleIsRequiredInEnglish";
    if (!errorRef.current) {
      errorRef.current = document.querySelector("#product-name-en");
    }
  } else if (obj.name_en?.trim()?.length > 250) {
    errors.name_en = "validation.productTitleIsTooLongInEnglish";
    if (!errorRef.current) {
      errorRef.current = document.querySelector("#product-name-en");
    }
  }

  if (!obj.category) {
    errors.category = "validation.selectCategory";
    if (!errorRef.current) {
      errorRef.current = document.querySelector("#product-category");
    }
  }

  if (obj.category && !obj.subCategory) {
    errors.subCategory = "validation.selectSubCategory";
    if (!errorRef.current) {
      errorRef.current = document.querySelector("#product-sub-category");
    }
  }

  if (obj.category && obj.subCategory && !obj.subSubCategory) {
    errors.subSubCategory = "validation.selectSubSubCategory";
    if (!errorRef.current) {
      errorRef.current = document.querySelector("#product-sub-sub-category");
    }
  }

  if (!obj.solutionType?.length) {
    errors.solutionType = "validation.selectSolutionType";
    if (!errorRef.current) {
      errorRef.current = document.querySelector("#product-solution-type");
    }
  }

  if (obj.productType === "normal") {
    if (!obj.price || isNaN(obj.price)) {
      errors.price = "validation.priceRequired";
      if (!errorRef.current) {
        errorRef.current = document.querySelector("#product-price");
      }
    } else if (obj.price < 0) {
      errors.price = "validation.priceCannotBeNegative";
      if (!errorRef.current) {
        errorRef.current = document.querySelector("#product-price");
      }
    }

    if (isNaN(obj.profitMargin)) {
      errors.profitMargin = "validation.profitMarginMustBeNumber";
      if (!errorRef.current) {
        errorRef.current = document.querySelector("#product-profit-margin");
      }
    } else if (obj.profitMargin < 0) {
      errors.profitMargin = "validation.profitMarginCannotBeNegative";
      if (!errorRef.current) {
        errorRef.current = document.querySelector("#product-profit-margin");
      }
    }

    if (isNaN(obj.discount)) {
      errors.discount = "validation.discountMustBeNumber";
      if (!errorRef.current) {
        errorRef.current = document.querySelector("#product-discount");
      }
    } else if (obj.discount < 0) {
      errors.discount = "validation.discountCannotBeNegative";
      if (!errorRef.current) {
        errorRef.current = document.querySelector("#product-discount");
      }
    }

    if (!obj.quantity || isNaN(obj.quantity)) {
      errors.quantity = "validation.quantityRequired";
      if (!errorRef.current) {
        errorRef.current = document.querySelector("#product-quantity");
      }
    } else if (obj.quantity < 0) {
      errors.quantity = "validation.quantityCannotBeNegative";
      if (!errorRef.current) {
        errorRef.current = document.querySelector("#product-quantity");
      }
    }

    if (!obj.sku) {
      errors.sku = "validation.skuRequired";
      if (!errorRef.current) {
        errorRef.current = document.querySelector("#product-sku");
      }
    } else if (obj.sku && !partialSkuRegex.test(obj.sku)) {
      errors.sku = "validation.invalidSku";
      if (!errorRef.current) {
        errorRef.current = document.querySelector("#product-sku");
      }
    }
  }

  // if (!obj.tags?.length) {
  //   errors.tags = "validation.selectMultipleMatchFit";
  //   if (!errorRef.current) {
  //     errorRef.current = document.querySelector("#product-tags");
  //   }
  // }

  if (!obj.description_ro?.trim()) {
    errors.description_ro = "validation.descriptionIsRequiredInRomanian";
    if (!errorRef.current) {
      errorRef.current = document.querySelector("#product-description-ro");
    }
  }

  if (!obj.description_en?.trim()) {
    errors.description_en = "validation.descriptionIsRequiredInEnglish";
    if (!errorRef.current) {
      errorRef.current = document.querySelector("#product-description-en");
    }
  }

  if (!obj.specification_en?.trim()) {
    errors.specification_en = "validation.specificationIsRequiredInEnglish";
    if (!errorRef.current) {
      errorRef.current = document.querySelector("#product-specification-en");
    }
  }

  if (!obj.specification_ro?.trim()) {
    errors.specification_ro = "validation.specificationIsRequiredInRomanian";
    if (!errorRef.current) {
      errorRef.current = document.querySelector("#product-specification-ro");
    }
  }

  setInputError(errors);
  return Object.keys(errors).length === 0;
};

const productInputEnglishValidation = (obj, setInputError, errorRef) => {
  let hasError = false;
  if (!obj.name_en?.trim()) {
    setInputError((prev) => ({ ...prev, name_en: true }));
    if (!errorRef.current) {
      errorRef.current = document.querySelector("#product-name-en");
    }
    hasError = true;
  }
  if (!obj.description_en?.trim()) {
    setInputError((prev) => ({ ...prev, description_en: true }));
    if (!errorRef.current) {
      errorRef.current = document.querySelector("#product-description-en");
    }
    hasError = true;
  }
  return hasError;
};

const addEditBasePackageValidation = (obj, setInputError, errorRef) => {
  let errors = {};

  if (!obj.name_ro?.trim()) {
    if (!errorRef.current) {
      errorRef.current = document.querySelector("#base-package-name-ro");
    }
    errors.name_ro = "validation.packageNameInRomanianRequired";
  }

  if (!obj.name_en?.trim()) {
    if (!errorRef.current) {
      errorRef.current = document.querySelector("#base-package-name-en");
    }
    errors.name_en = "validation.packageNameInEnglishRequired";
  }

  if (!obj.category) {
    if (!errorRef.current) {
      errorRef.current = document.querySelector("#base-package-category");
    }
    errors.category = "validation.categoryRequired";
  }

  if (!obj.solutionType?.length) {
    if (!errorRef.current) {
      errorRef.current = document.querySelector("#base-package-solution-type");
    }
    errors.solutionType = "validation.solutionTypeRequired";
  }

  if (!obj.tags?.length) {
    if (!errorRef.current) {
      errorRef.current = document.querySelector("#base-package-tags");
    }
    errors.tags = "validation.selectAtLeastTwoMatchFit";
  }

  if (!obj.description_ro?.trim()) {
    if (!errorRef.current) {
      errorRef.current = document.querySelector("#base-package-description-ro");
    }
    errors.description_ro = "validation.packageDescriptionInRomanianRequired";
  }

  if (!obj.description_en?.trim()) {
    if (!errorRef.current) {
      errorRef.current = document.querySelector("#base-package-description-en");
    }
    errors.description_en = "validation.packageDescriptionInEnglishRequired";
  }

  if (!obj.specification_en?.trim()) {
    if (!errorRef.current) {
      errorRef.current = document.querySelector(
        "#base-package-specification-en",
      );
    }
    errors.specification_en =
      "validation.packageSpecificationInEnglishRequired";
  }
  if (!obj.specification_ro?.trim()) {
    if (!errorRef.current) {
      errorRef.current = document.querySelector(
        "#base-package-specification-ro",
      );
    }
    errors.specification_ro =
      "validation.packageSpecificationInRomanianRequired";
  }

  setInputError(errors);
  return Object.keys(errors).length > 0;
};

const addEditBlogValidation = (obj, setInputError, errorRef) => {
  let errors = {};

  if (!obj.image) {
    errors.image = "validation.imageRequired";
    if (!errorRef.current) {
      errorRef.current = document.querySelector("#blog-image");
    }
  }

  // if (!obj.category) {
  //   errors.category = "validation.selectBlogCategory";
  //   if (!errorRef.current) {
  //     errorRef.current = document.querySelector("#blog-category");
  //   }
  // }

  if (!obj.topic) {
    errors.topic = "validation.selectBlogTopic";
    if (!errorRef.current) {
      errorRef.current = document.querySelector("#blog-topic");
    }
  }

  if (!obj.title_ro?.trim()) {
    errors.title_ro = "validation.titleInRomanianRequired";
    if (!errorRef.current) {
      errorRef.current = document.querySelector("#blog-title-ro");
    }
  } else if (obj.title_ro?.trim()?.length > 255) {
    errors.title_ro = "validation.titleInRomanianIsTooLong";
    if (!errorRef.current) {
      errorRef.current = document.querySelector("#blog-title-ro");
    }
  }

  if (!obj.title_en?.trim()) {
    errors.title_en = "validation.titleInEnglishRequired";
    if (!errorRef.current) {
      errorRef.current = document.querySelector("#blog-title-en");
    }
  } else if (obj.title_en?.trim()?.length > 255) {
    errors.title_en = "validation.titleInEnglishIsTooLong";
    if (!errorRef.current) {
      errorRef.current = document.querySelector("#blog-title-en");
    }
  }

  if (!obj.smallDescription_en?.trim()) {
    errors.smallDescription_en = "validation.smallDescriptionInEnglishRequired";
    if (!errorRef.current) {
      errorRef.current = document.querySelector("#blog-smallDescription-en");
    }
  } else if (obj.smallDescription_en?.trim()?.length > 500) {
    errors.smallDescription_en =
      "validation.smallDescriptionInEnglishIsTooLong";
    if (!errorRef.current) {
      errorRef.current = document.querySelector("#blog-smallDescription-en");
    }
  }
  if (!obj.smallDescription_ro?.trim()) {
    errors.smallDescription_ro =
      "validation.smallDescriptionInRomanianRequired";
    if (!errorRef.current) {
      errorRef.current = document.querySelector("#blog-smallDescription-ro");
    }
  } else if (obj.smallDescription_ro?.trim()?.length > 500) {
    errors.smallDescription_ro =
      "validation.smallDescriptionInRomanianIsTooLong";
    if (!errorRef.current) {
      errorRef.current = document.querySelector("#blog-smallDescription-ro");
    }
  }

  if (!obj.description_en?.trim()) {
    errors.description_en = "validation.longDescriptionInEnglishRequired";
    if (!errorRef.current) {
      errorRef.current = document.querySelector("#blog-description-en");
    }
  }
  if (!obj.description_ro?.trim()) {
    errors.description_ro = "validation.longDescriptionInRomanianRequired";
    if (!errorRef.current) {
      errorRef.current = document.querySelector("#blog-description-ro");
    }
  }

  setInputError(errors);
  return Object.keys(errors).length > 0;
};

const addEditUserPackageValidation = (obj, setInputError, errorRef) => {
  let errors = {};

  if (!obj.name_ro?.trim()) {
    if (!errorRef.current) {
      errorRef.current = document.querySelector("#user-package-name-ro");
    }
    errors.name_ro = "validation.packageNameInRomanianRequired";
  }
  if (!obj.name_en?.trim()) {
    if (!errorRef.current) {
      errorRef.current = document.querySelector("#user-package-name-en");
    }
    errors.name_en = "validation.packageNameInEnglishRequired";
  }
  if (!obj.description_ro?.trim()) {
    if (!errorRef.current) {
      errorRef.current = document.querySelector("#user-package-description-ro");
    }
    errors.description_ro = "validation.packageDescriptionInRomanianRequired";
  }
  if (!obj.description_en?.trim()) {
    if (!errorRef.current) {
      errorRef.current = document.querySelector("#user-package-description-en");
    }
    errors.description_en = "validation.packageDescriptionInEnglishRequired";
  }
  if (!obj.specification_ro?.trim()) {
    if (!errorRef.current) {
      errorRef.current = document.querySelector(
        "#user-package-specifications-ro",
      );
    }
    errors.specification_ro =
      "validation.packageSpecificationInRomanianRequired";
  }
  if (!obj.specification_en?.trim()) {
    if (!errorRef.current) {
      errorRef.current = document.querySelector(
        "#user-package-specifications-en",
      );
    }
    errors.specification_en =
      "validation.packageSpecificationInEnglishRequired";
  }
  if (!obj.tags?.length) {
    if (!errorRef.current) {
      errorRef.current = document.querySelector("#user-package-tags");
    }
    errors.tags = "validation.selectAtLeastTwoMatchFit";
  }
  setInputError(errors);
  return Object.keys(errors).length > 0;
};

const addEditProductSizeValidation = (obj, setInputError) => {
  const errors = {};
  // Size
  if (!obj.size) errors.size = "sizeIsRequired";
  // Quantity
  if (!obj.quantity) {
    errors.quantity = "quantityIsRequired";
  } else if (obj.quantity && obj.quantity < 0) {
    errors.quantity = "quantityCannotBeNegative";
  }

  // Price
  if (!obj.price) {
    errors.price = "priceIsRequired";
  } else if (obj.price && obj.price < 0) {
    errors.price = "priceCannotBeNegative";
  }

  // Profit margin
  if (isNaN(obj.profitMargin)) {
    errors.profitMargin = "profitMarginCannotBeEmpty";
  }

  if (isNaN(obj.discount)) {
    errors.discount = "discountCannotBeEmpty";
  }

  // SKU
  if (!obj.sku) {
    errors.sku = "skuIsRequired";
  } else if (obj.sku && !partialSkuRegex.test(obj.sku)) {
    errors.sku = "invalidSku";
  }

  setInputError(errors);
  return Object.keys(errors).length === 0;
};

const addEditProductColorValidation = (obj, setInputError) => {
  const errors = {};
  // Size
  if (!obj.color) errors.color = "colorIsRequired";
  // Quantity
  if (!obj.quantity) {
    errors.quantity = "quantityIsRequired";
  } else if (obj.quantity && obj.quantity < 0) {
    errors.quantity = "quantityCannotBeNegative";
  }

  // Price
  if (!obj.price) {
    errors.price = "priceIsRequired";
  } else if (obj.price && obj.price < 0) {
    errors.price = "priceCannotBeNegative";
  }

  // Profit margin
  if (isNaN(obj.profitMargin)) {
    errors.profitMargin = "profitMarginCannotBeEmpty";
  }

  if (isNaN(obj.discount)) {
    errors.discount = "discountCannotBeEmpty";
  }

  // SKU
  if (!obj.sku) {
    errors.sku = "skuIsRequired";
  } else if (obj.sku && !partialSkuRegex.test(obj.sku)) {
    errors.sku = "invalidSku";
  }

  setInputError(errors);
  return Object.keys(errors).length === 0;
};

const addEditEcommerceTagsValidation = (obj, setInputError) => {
  let errors = {};

  if (!obj.icon) {
    errors.icon = "validation.iconRequired";
  }
  if (!obj.name_ro?.trim()) {
    errors.name_ro = "validation.tagNameInRomanianRequired";
  }
  if (!obj.name_en?.trim()) {
    errors.name_en = "validation.tagNameInEnglishRequired";
  }
  if (!obj.description_en?.trim()) {
    errors.description_en = "validation.tagDescriptionRequiredInEnglish";
  }
  if (!obj.description_ro?.trim()) {
    errors.description_ro = "validation.tagDescriptionRequiredInRomanian";
  }
  if (!obj.order || isNaN(obj.order)) {
    errors.order = "validation.tagOrderRequired";
  } else if (obj.order < 0) {
    errors.order = "validation.tagOrderMustBeGreaterThanZero";
  }
  if (!obj.solutionType?.length) {
    errors.solutionType = "validation.solutionTypeRequired";
  }
  if (!obj.appliesTo) {
    errors.appliesTo = "validation.appliesToRequired";
  }
  setInputError(errors);
  return Object.keys(errors).length > 0;
};

const addEditBannerValidation = (obj, setInputError) => {
  let errors = {};

  if (!obj.image_desktop_en) {
    errors.image_desktop_en = "validation.imageRequired";
  }

  if (!obj.image_desktop_ro) {
    errors.image_desktop_ro = "validation.imageRequired";
  }

  // Mobile banner upload temporarily disabled
  // if (!obj.image_mobile_en) {
  //   errors.image_mobile_en = "validation.imageRequired";
  // }

  // if (!obj.image_mobile_ro) {
  //   errors.image_mobile_ro = "validation.imageRequired";
  // }

  if (!obj.title_ro?.trim()) {
    errors.title_ro = "validation.bannerTitleInRomanianRequired";
  }

  if (!obj.title_en?.trim()) {
    errors.title_en = "validation.bannerTitleInEnglishRequired";
  }

  if (!obj.order || isNaN(obj.order)) {
    errors.order = "validation.tagOrderRequired";
  } else if (obj.order < 0) {
    errors.order = "validation.tagOrderMustBeGreaterThanZero";
  }

  if (!obj.position) {
    errors.position = "validation.bannerPositionRequired";
  }

  if (obj.link?.trim() && !urlRegex.test(obj.link)) {
    errors.link = "validation.invalidRedirectUrl";
  }

  setInputError(errors);
  return Object.keys(errors).length > 0;
};

const addEditFaqValidation = (obj, setInputError) => {
  let errors = {};
  if (!obj.question_ro?.trim()) {
    errors.question_ro = "validation.questionInRomanianRequired";
  } else if (obj.question_ro?.trim().length > 250) {
    errors.question_ro = "validation.questionInRomanianIsTooLong";
  }
  if (!obj.question_en?.trim()) {
    errors.question_en = "validation.questionInEnglishRequired";
  } else if (obj.question_en?.trim().length > 250) {
    errors.question_en = "validation.questionInEnglishIsTooLong";
  }

  if (!obj.answer_ro?.trim()) {
    errors.answer_ro = "validation.answerInRomanianRequired";
  } else if (obj.answer_ro?.trim().length > 1000) {
    errors.answer_ro = "validation.answerInRomanianIsTooLong";
  }

  if (!obj.answer_en?.trim()) {
    errors.answer_en = "validation.answerInEnglishRequired";
  } else if (obj.answer_en?.trim().length > 1000) {
    errors.answer_en = "validation.answerInEnglishIsTooLong";
  }

  setInputError(errors);
  return Object.keys(errors).length > 0;
};

const addCustomVaraintValuesValidation = (obj, setInputError) => {
  let errors = {};
  if (!obj.label?.trim()) {
    errors.label = "validation.labelIsRequired";
  }

  if (!obj.value?.trim()) {
    errors.value = "validation.valueIsRequired";
  }

  setInputError(errors);
  return Object.keys(errors).length > 0;
};

const addEditAttributeValidation = (obj, setInputError) => {
  let errors = {};

  if (!obj.label_ro?.trim()) {
    errors.label_ro = "validation.attributeNameInRomanianIsRequired";
  } else if (obj.label_ro?.trim().length > 60) {
    errors.label_ro = "validation.attributeNameInRomanianIsTooLong";
  }

  if (!obj.label_en?.trim()) {
    errors.label_en = "validation.attributeNameInEnglishIsRequired";
  } else if (obj.label_en?.trim().length > 60) {
    errors.label_en = "validation.attributeNameInEnglishIsTooLong";
  }

  if (!obj.order || isNaN(obj.order)) {
    errors.order = "validation.attributeOrderIsRequired";
  } else if (obj.order < 0) {
    errors.order = "validation.attributeOrderMustBeGreaterThanZero";
  }

  setInputError(errors);
  return Object.keys(errors).length > 0;
};

const addEditAttributeValuesValidation = (obj, setInputError) => {
  let errors = {};
  if (!obj.label_ro?.trim()) {
    errors.label_ro = "validation.attributeValueLabelIsRequiredInRomanian";
  }
  if (!obj.label_en?.trim()) {
    errors.label_en = "validation.attributeValueLabelIsRequiredInEnglish";
  }
  if (!obj.order || isNaN(obj.order)) {
    errors.order = "validation.attributeValueOrderRequired";
  } else if (obj.order < 0) {
    errors.order = "validation.attributeValueOrderMustBeGreaterThanZero";
  }

  setInputError(errors);
  return Object.keys(errors).length > 0;
};

const addEditDiscountRuleValidation = (obj, setInputError) => {
  let errors = {};
  if (!obj.name_ro?.trim()) {
    errors.name_ro = "validation.discountRuleNameInRomanianRequired";
  }
  if (!obj.name_en?.trim()) {
    errors.name_en = "validation.discountRuleNameInEnglishRequired";
  }
  if (!obj.description_ro?.trim()) {
    errors.description_ro =
      "validation.discountRuleDescriptionInRomanianRequired";
  }
  if (!obj.description_en?.trim()) {
    errors.description_en =
      "validation.discountRuleDescriptionInEnglishRequired";
  }
  if (!obj.minAmount || isNaN(obj.minAmount)) {
    errors.minAmount = "validation.minAmountIsRequired";
  } else if (obj.minAmount < 0) {
    errors.minAmount = "validation.minAmountCannotBeNegative";
  }

  if (!obj.discountAmount || isNaN(obj.discountAmount)) {
    errors.discountAmount = "validation.discountAmountIsRequired";
  } else if (obj.discountAmount < 0) {
    errors.discountAmount = "validation.discountAmountCannotBeNegative";
  } else if (obj.discountAmount >= obj.minAmount) {
    errors.discountAmount =
      "validation.discountAmountCannotBeGreaterThanOrEqualToMinAmount";
  }

  if (!obj.startDate) {
    errors.startDate = "validation.startDateIsRequired";
  } else if (obj.startDate > obj.endDate) {
    errors.startDate = "validation.startDateMustBeBeforeEndDate";
  }
  if (!obj.endDate) {
    errors.endDate = "validation.endDateIsRequired";
  } else if (obj.endDate < obj.startDate) {
    errors.endDate = "validation.endDateMustBeAfterStartDate";
  }

  setInputError(errors);
  return Object.keys(errors).length > 0;
};

const restockProductValidation = (
  obj,
  setInputError,
  isPriceApplied,
  isQuantityApplied,
) => {
  let errors = {};

  if (isQuantityApplied) {
    if (!obj.quantity || isNaN(obj.quantity)) {
      errors.quantity = "validation.quantityRequired";
    } else if (obj.quantity < 0) {
      errors.quantity = "validation.quantityCannotBeNegative";
    }
  }

  if (isPriceApplied) {
    if (!obj.price || isNaN(obj.price)) {
      errors.price = "validation.priceRequired";
    } else if (obj.price < 0) {
      errors.price = "validation.priceCannotBeNegative";
    }

    if (isNaN(obj.profitMargin)) {
      errors.profitMargin = "validation.profitMarginMustBeNumber";
    } else if (obj.profitMargin < 0) {
      errors.profitMargin = "validation.profitMarginCannotBeNegative";
    }

    if (isNaN(obj.discount)) {
      errors.discount = "validation.discountMustBeNumber";
    } else if (obj.discount < 0) {
      errors.discount = "validation.discountCannotBeNegative";
    }
  }

  setInputError(errors);
  return Object.keys(errors).length > 0;
};

const addEditPromotionalBlockValidation = (obj, setInputError) => {
  let errors = {};
  if (!obj.image_en) {
    errors.image_en = "validation.imageRequired";
  }
  if (!obj.image_ro) {
    errors.image_ro = "validation.imageRequired";
  }
  if (!obj.title_en?.trim()) {
    errors.title_en = "validation.titleInEnglishIsRequired";
  }
  if (!obj.title_ro?.trim()) {
    errors.title_ro = "validation.titleInRomanianIsRequired";
  }
  if (obj.link_en?.trim() && !urlRegex.test(obj.link_en)) {
    errors.link_en = "validation.invalidRedirectUrl";
  }
  if (obj.link_ro?.trim() && !urlRegex.test(obj.link_ro)) {
    errors.link_ro = "validation.invalidRedirectUrl";
  }
  if (!obj.page) {
    errors.page = "validation.pageIsRequired";
  }
  if (!obj.positionType) {
    errors.positionType = "validation.positionTypeIsRequired";
  }
  if (!obj.startDate) {
    errors.startDate = "validation.startDateIsRequired";
  }
  if (!obj.endDate) {
    errors.endDate = "validation.endDateIsRequired";
  }
  setInputError(errors);
  return Object.keys(errors).length > 0;
};

const addEditSocialMediaLinksValidation = (obj, setInputError) => {
  let errors = {};
  if (!obj.facebookPageLink?.trim()) {
    errors.facebookPageLink = "validation.facebookLinkIsRequired";
  } else if (
    obj.facebookPageLink?.trim() &&
    !urlRegex.test(obj.facebookPageLink)
  ) {
    errors.facebookPageLink = "validation.invalidRedirectUrl";
  }

  if (!obj.instagramLink?.trim()) {
    errors.instagramLink = "validation.instagramLinkIsRequired";
  } else if (obj.instagramLink?.trim() && !urlRegex.test(obj.instagramLink)) {
    errors.instagramLink = "validation.invalidRedirectUrl";
  }

  if (!obj.youtubeLink?.trim()) {
    errors.youtubeLink = "validation.youtubeLinkIsRequired";
  } else if (obj.youtubeLink?.trim() && !urlRegex.test(obj.youtubeLink)) {
    errors.youtubeLink = "validation.invalidRedirectUrl";
  }

  if (!obj.linkedinLink?.trim()) {
    errors.linkedinLink = "validation.linkedinLinkIsRequired";
  } else if (obj.linkedinLink?.trim() && !urlRegex.test(obj.linkedinLink)) {
    errors.linkedinLink = "validation.invalidRedirectUrl";
  }

  if (!obj.twitterLink?.trim()) {
    errors.twitterLink = "validation.twitterLinkIsRequired";
  } else if (obj.twitterLink?.trim() && !urlRegex.test(obj.twitterLink)) {
    errors.twitterLink = "validation.invalidRedirectUrl";
  }

  if (!obj.tiktokLink?.trim()) {
    errors.tiktokLink = "validation.tiktokLinkIsRequired";
  } else if (obj.tiktokLink?.trim() && !urlRegex.test(obj.tiktokLink)) {
    errors.tiktokLink = "validation.invalidRedirectUrl";
  }

  setInputError(errors);
  return Object.keys(errors).length > 0;
};

const addEditPregnancyWeekValidation = (obj, setInputError) => {
  let errors = {};

  if (!obj.pregnancyWeekHighlightsTitle_ro?.trim()) {
    errors.pregnancyWeekHighlightsTitle_ro =
      "validation.pregnancyWeekHighlightsTitleInRomanianIsRequired";
  }

  if (!obj.pregnancyWeekHighlightsTitle_en?.trim()) {
    errors.pregnancyWeekHighlightsTitle_en =
      "validation.pregnancyWeekHighlightsTitleInEnglishIsRequired";
  }

  if (!obj.pregnancyWeekHighlightsLink_ro?.trim()) {
    errors.pregnancyWeekHighlightsLink_ro =
      "validation.pregnancyWeekHighlightsLinkInRomanianIsRequired";
  } else if (
    obj.pregnancyWeekHighlightsLink_ro?.trim() &&
    !urlRegex.test(obj.pregnancyWeekHighlightsLink_ro)
  ) {
    errors.pregnancyWeekHighlightsLink_ro = "validation.invalidRedirectUrl";
  }

  if (!obj.pregnancyWeekHighlightsLink_en?.trim()) {
    errors.pregnancyWeekHighlightsLink_en =
      "validation.pregnancyWeekHighlightsLinkInEnglishIsRequired";
  } else if (
    obj.pregnancyWeekHighlightsLink_en?.trim() &&
    !urlRegex.test(obj.pregnancyWeekHighlightsLink_en)
  ) {
    errors.pregnancyWeekHighlightsLink_en = "validation.invalidRedirectUrl";
  }

  setInputError(errors);
  return Object.keys(errors).length > 0;
};

const addEditCharityOrganizationValidation = (obj, setInputError) => {
  let errors = {};
  if (isNaN(obj.order)) {
    errors.order = "validation.orderIsRequired";
  } else if (obj.order < 0) {
    errors.order = "validation.orderMustBeGreaterThanZero";
  }
  if (obj.websiteUrl?.trim() && !urlRegex.test(obj.websiteUrl)) {
    errors.websiteUrl = "validation.invalidWebsiteUrl";
  }
  if (!obj.name_en?.trim()) {
    errors.name_en = "validation.nameInEnglishIsRequired";
  }
  if (!obj.name_ro?.trim()) {
    errors.name_ro = "validation.nameInRomanianIsRequired";
  }

  if (!obj.description_en?.trim()) {
    errors.description_en = "validation.descriptionInEnglishIsRequired";
  }
  if (!obj.description_ro?.trim()) {
    errors.description_ro = "validation.descriptionInRomanianIsRequired";
  }
  setInputError(errors);
  return Object.keys(errors).length > 0;
};

const addEditBrandValidation = (obj, setInputError) => {
  let errors = {};

  // if (!obj.logo) {
  //   errors.logo = "validation.logoRequired";
  // }
  if (!obj.title_en?.trim()) {
    errors.title_en = "validation.nameInEnglishIsRequired";
  }
  if (!obj.title_ro?.trim()) {
    errors.title_ro = "validation.nameInRomanianIsRequired";
  }
  if (!obj.description_en?.trim()) {
    errors.description_en = "validation.descriptionInEnglishIsRequired";
  }
  if (!obj.description_ro?.trim()) {
    errors.description_ro = "validation.descriptionInRomanianIsRequired";
  }
  setInputError(errors);
  return Object.keys(errors).length > 0;
};

const addEditBlogTopicValidation = (obj, setInputError) => {
  let errors = {};

  if (!obj.title_en?.trim()) {
    errors.title_en = "validation.nameInEnglishIsRequired";
  }
  if (!obj.title_ro?.trim()) {
    errors.title_ro = "validation.nameInRomanianIsRequired";
  }
  // if (!obj.description_en?.trim()) {
  //   errors.description_en = "validation.descriptionInEnglishIsRequired";
  // }
  // if (!obj.description_ro?.trim()) {
  //   errors.description_ro = "validation.descriptionInRomanianIsRequired";
  // }
  setInputError(errors);
  return Object.keys(errors).length > 0;
};

const addEditGiftCardValidation = (obj, setInputError) => {
  let errors = {};

  if (!obj.image) {
    errors.image = "validation.imageRequired";
  }
  if (!obj.amount || isNaN(obj.amount)) {
    errors.amount = "validation.gitCardAmountRequired";
  }
  if (!obj.title_en?.trim()) {
    errors.title_en = "validation.nameInEnglishIsRequired";
  }
  if (!obj.title_ro?.trim()) {
    errors.title_ro = "validation.nameInRomanianIsRequired";
  }
  if (!obj.description_en?.trim()) {
    errors.description_en = "validation.descriptionInEnglishIsRequired";
  }
  if (!obj.description_ro?.trim()) {
    errors.description_ro = "validation.descriptionInRomanianIsRequired";
  }
  setInputError(errors);
  return Object.keys(errors).length > 0;
};

export {
  loginValidation,
  signupValidation,
  forgotValidation,
  resetValidation,
  changePasswordValidation,
  serviceCategoryValidation,
  addEcomCategoryValidation,
  serviceSubCategoryValidation,
  addEditProductValidation,
  addEditBasePackageValidation,
  addEditEcomSubCategoryValidation,
  addEditBlogValidation,
  productInputEnglishValidation,
  addEditProductSizeValidation,
  addEditProductColorValidation,
  addEditUserPackageValidation,
  addEditEcomSubSubCategoryValidation,
  addEditEcommerceTagsValidation,
  addEditBannerValidation,
  addEditFaqValidation,
  addCustomVaraintValuesValidation,
  addEditAttributeValidation,
  addEditAttributeValuesValidation,
  addEditDiscountRuleValidation,
  restockProductValidation,
  addEditPromotionalBlockValidation,
  addEditSocialMediaLinksValidation,
  addEditCharityOrganizationValidation,
  addEditBrandValidation,
  addEditGiftCardValidation,
  addEditBlogTopicValidation,
  addEditPregnancyWeekValidation,
};
